import { SinglePageType } from "containers/PageSingle/PageSingle";
import { DEMO_TAGS } from "./taxonomies";
import __comments from "./jsons/__comments.json";
import a10 from "./avatars/3.jpg";
import { DEMO_AUTHORS } from "./authors";
import { CommentType } from "components/CommentCard/CommentCard";


const nest = (
  items: CommentType[],
  id: number | null | undefined
): CommentType[] => {
  return items
    .filter((item) => item.parentId === id)
    .map((item) => ({
      ...item,
      children: nest(items, item.id as number | null),
    }));
};

const commentHasAuthor = __comments.map((item) => ({
  ...item,
  author: DEMO_AUTHORS[Math.floor(Math.random() * 10)],
}));

export const DEMO_COMMENTS = nest(commentHasAuthor, null);
export const SINGLE: SinglePageType = {
  id: "eae0212192f63287e0c212",
  featuredImage:
    "",
  title: "",
  desc: "",
  date: "",
  href: "/",
  commentCount: 1,
  viewdCount: 1,
  readingTime: 1,
  bookmark: { count: 1, isBookmarked: false },
  like: { count: 1, isLiked: true },
  author: {
    id: 1,
    firstName: "First Name",
    lastName: "Last Name",
    displayName: "Full Name",
    email: "Email",
    avatar: a10,
    count: 38,
    href: "/",
    desc: "",
    jobName: "",
  },
  categories: [
    {
      id: 3,
      name: "CryptoVerse",
      href: "/",
      thumbnail:
        "0",
      count: 1,
      color: "yellow",
      taxonomy: "category",
    },
  ],
  postType: "standard",
  tags: [DEMO_TAGS[0], DEMO_TAGS[1], DEMO_TAGS[3]],
  content: "",
  comments: DEMO_COMMENTS,
};
